import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=a40d3346&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"
import style0 from "./AboutContent.vue?vue&type=style&index=0&id=a40d3346&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40d3346",
  null
  
)

export default component.exports